export const AUTHENTICATE_FAILURE = 'AUTHENTICATE_FAILURE';

export const authenticateFailure = error => ({
    type: AUTHENTICATE_FAILURE,
    payload: error,
    error: true,
});
